function sortAsc(a, b) {
  const aHasFrom =
    a &&
    a.data &&
    a.data.prices &&
    a.data.prices.scheduled &&
    a.data.prices.scheduled.buy &&
    a.data.prices.scheduled.buy.from !== undefined;

  const bHasFrom =
    b &&
    b.data &&
    b.data.prices &&
    b.data.prices.scheduled &&
    b.data.prices.scheduled.buy &&
    b.data.prices.scheduled.buy.from !== undefined;

  if (!aHasFrom && !bHasFrom) {
    return 0;
  }

  if (aHasFrom && !bHasFrom) {
    return 1;
  }

  if (!aHasFrom && bHasFrom) {
    return -1;
  }

  const aFrom = a.data.prices.scheduled.buy.from;
  const bFrom = b.data.prices.scheduled.buy.from;

  if (aFrom === bFrom) {
    return 0;
  }

  return aFrom > bFrom ? 1 : -1;
}

function sortDesc(a, b) {
  const aHasFrom =
    a &&
    a.data &&
    a.data.prices &&
    a.data.prices.scheduled &&
    a.data.prices.scheduled.buy &&
    a.data.prices.scheduled.buy.from !== undefined;

  const bHasFrom =
    b &&
    b.data &&
    b.data.prices &&
    b.data.prices.scheduled &&
    b.data.prices.scheduled.buy &&
    b.data.prices.scheduled.buy.from !== undefined;

  if (!aHasFrom && !bHasFrom) {
    return 0;
  }

  if (aHasFrom && !bHasFrom) {
    return -1;
  }

  if (!aHasFrom && bHasFrom) {
    return 1;
  }

  const aFrom = a.data.prices.scheduled.buy.from;
  const bFrom = b.data.prices.scheduled.buy.from;

  if (aFrom === bFrom) {
    return 0;
  }

  return aFrom > bFrom ? -1 : 1;
}

function filter_scheduled(items, params) {
  const period = params[0] || 'current';
  const now = params[1] || Math.round((new Date()).getTime() / 1000);

  const filteredItems = items.filter((item) => {
    switch (period) {
      default:
      case 'past':
        return !item.data
          || !item.data.prices
          || !item.data.prices.scheduled
          || !item.data.prices.scheduled.buy
          || !item.data.prices.scheduled.buy.until
          || item.data.prices.scheduled.buy.until < now;

      case 'future':
        return item.data
          && item.data.prices
          && item.data.prices.scheduled
          && item.data.prices.scheduled.buy
          && item.data.prices.scheduled.buy.from
          && item.data.prices.scheduled.buy.from > now;

      case 'current':
        return item.data
          && item.data.prices
          && item.data.prices.scheduled
          && item.data.prices.scheduled.buy
          && item.data.prices.scheduled.buy.until
          && item.data.prices.scheduled.buy.from
          && item.data.prices.scheduled.buy.until >= now
          && item.data.prices.scheduled.buy.from <= now;
    }
  });

  if (period === 'past') {
    filteredItems.sort(sortDesc);
  } else {
    filteredItems.sort(sortAsc);
  }

  return filteredItems;
}

module.exports = filter_scheduled;



// WEBPACK FOOTER //
// ./src/libs/twig/filter_scheduled/index.js